<template>
  <router-link
    v-set-test-id="['BaseRouterLink', testId || to]"
    :to="to"
    v-bind="$attrs"
  >
    <slot name="default" />
  </router-link>
</template>

<script lang="ts" setup>
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';
import type { ZvdZLocationRaw } from '@/plugins/router';

type Props = ActionableComponentProps & {
  to: ZvdZLocationRaw;
};
defineProps<Props>();
</script>
